/* ADD GROUPS */
export const RESET_GROUP_COURSE = "RESET_GROUP_COURSE"
export const RESET_GROUP_COURSE_SUCCESS = "RESET_GROUP_COURSE_SUCCESS"
export const RESET_GROUP_COURSE_CLEAN = "RESET_GROUP_COURSE_CLEAN"
export const RESET_GROUP_COURSE_ERROR = "RESET_GROUP_COURSE_ERROR"
